export const winners2025 = [
  {
    id: '1',
    name: 'Sumario Lim',
    organization: 'Sinar Mas Agribusiness and Food',
    pillar: 'Agri-business & Food',
    orgUnit: 'Upstream',
    title: 'Digitalization Team Lead',
    teamMembers: [],
    description:
      'eFACT2.0 (electronic field activity capture and traceability) - Driving work behavior and improve operational efficiency, enabling higher yield and productivity across plantation operations.',
    image: '/awards/winner-1.jpg',
    award: 'Digital Transformation',
    year: 2025,
    category: 'team',
    linkedIn: '#',
    projectLink:
      'https://srxaiagents.blob.core.windows.net/uploads/submissions/1756742700920_SMDD_Award_2025_-_Sinar_Mas_Agribusiness_and_Food_-_Digital_Transformation_Champion_Award_-_eFACT_2.0_Enabling_Smarter_Field_Operation.pptx?sv=2025-07-05&spr=https&se=2027-09-01T1',
    videoUrl:
      'https://srxaiagents.blob.core.windows.net/uploads/submissions/1756742713477_SMDD_Award_2025_-_Sinar_Mas_Agribusiness_and_Food_-_Digital_Transformation_Champion_Award_-_eFACT_2.0_Enabling_Smarter_Field_Operation.mp4?sv=2025-07-05&spr=https&se=2027-09-01T16',
    details: `=== Impact on Business Performance ===

• Transforming manual data capture to digital intelligence improved decision making and KPI monitoring, contributing to a reported 67% reduction in unharvested blocks, minimizing field losses.
• Implemented GPS tracking and AI-based systems for real-time tracking and traceability, leading to improved operational accountability and reduced errors, aligning with strategic goals.
• eFACT 2.0 led to significant reductions in incomplete eSPB from over 150 to less than 10 per month, directly impacting performance metrics and operational efficiency.

=== Innovation and Creativity in Implementation ===

• Introduced an 'Offline-first & Inclusive Innovation' approach, designed to work in no-connectivity environments with user-friendly apps, addressing digital literacy issues.
• Used AI grading, computer vision, and IoT for data-driven decisions, disrupting traditional processes and providing new insights for field operations.
• The generative AI chatbot offers real-time SOP guidance, enhancing compliance and driving operational improvements through innovative solutions.

=== Scalability and Implementation Success ===

• Successfully scaled across 137 estates and 8 PSMs with over 8,000 devices, enabling measurable impacts and strong adoption by executives, managers, and field workers.
• Systemized SOPs across 26 regions with more than 500K HA managed areas, reinforcing compliance and facilitating efficient scaling across units.
• Deployed an agile co-creation and scalability strategy using a train-the-trainer approach, bolstering workforce readiness and boosting implementation success.`,
  },
  {
    id: '2',
    name: 'Aldrich Widjaja',
    organization: 'Eka Hospital',
    pillar: 'Healthcare',
    orgUnit: 'Eka Hospital',
    title: 'Data Application Specialist',
    teamMembers: [],
    description: 'Smart MCU: AI-Orchestrated Medical Checkup System',
    image: '/awards/winner-2.jpg',
    award: 'AI Breakthrough',
    year: 2025,
    category: 'team',
    linkedIn: '#',
    projectLink: '#',
    details: `=== Technology & Innovation ===
• Ingests HIS data and outputs from Lab, Radiology, and ECG to create standardized, explainable MCU reports under doctor oversight.
• Orchestration engine (Eka.AI) utilizes frontier LLMs (Gemini 2.5 Pro, GPT-5 Thinking) for superior medical reasoning and clinical accuracy.
• Statement-to-source traceability allows doctors to verify AI findings against exact LIS/RIS/ECG fields and medical guidelines.
• Feature-rich doctor dashboard with redline/edit capabilities and evidence-view for absolute clinical safety.

=== Impact & Results ===
• MCU turnaround time significantly reduced from ≤168h to ≤24h (7× improvement).
• Doctor interpretation time per MCU case reduced from ~30 min to ~6 min (5× faster).
• Doctor throughput increased from ~15 to ~75 cases per day (5× capacity).
• Maintained clinical accuracy target of ≥95% on AI-generated MCU interpretations.

=== Scalability & Success ===
• Designed for multi-site deployment across all Eka Hospital units using per-site HIS connectors.
• Robust MLOps with model version pinning, drift monitors, and automated latency/cost logging.
• Full Human-in-the-Loop (HITL) integration ensures high adoption and patient safety.

=== Future Roadmap & Governance ===
• Clinical Governance: Final physician sign-off is mandatory with every statement traceable to raw data.
• Roadmap: Towards a consolidated Patient 360 view, unifying lifestyle and clinical signals to anticipate risks earlier.`,
  },
  {
    id: '3',
    name: 'Lukas Kristianto',
    organization: 'APP Group',
    pillar: 'Pulp & Paper',
    orgUnit: 'HQ',
    title: 'Specialist Mobile Application and AI Developer',
    teamMembers: [],
    description:
      'Visionary leader in mobile and AI development, known for driving APP’s digital transformation through standardized mobile practices and pioneering AI on Edge solutions to solve critical operational challenges.',
    image: '/awards/winner-3.jpg',
    award: 'Young Digital Leader',
    year: 2025,
    category: 'individual',
    linkedIn: '#',
    projectLink: '#',
    details: `=== Digital Leadership & Innovation ===
• Standardized mobile development at APP, drawing from Tokopedia experience to implement robust processes, coaching, and mentoring for high-quality iOS/Android apps.
• Pioneered 'AI on Edge' solutions, including an AI-powered OCR system that reads odometer data offline, significantly reducing fuel fraud in remote forestry sites.
• Developed a Generative AI LLM solution for the CMI business unit, providing real-time strategic insights into market share and competitive dynamics via mobile devices.
• Led 19 successful digital initiatives over 4 years, bridging the gap between technology, forestry operations, and business teams.

=== Business Impact & Results ===
• Developed an in-house Sales Force Application (SFA) supporting 1,300+ salespeople across 4 countries, facilitating over $709 billion in transactions.
• In-house SFA initiative generated ~$170,000 in cost savings since 2022 by eliminating vendor fees and reducing development costs.
• AI on Edge odometer project detected and prevented vendor fraud, resulting in savings of up to $590,000 in audit-finding losses.
• Daily Dashboard Report (CMI) reduced data gathering/analysis time from 8 hours to real-time, empowering faster management decisions.

=== Multi-Platform & Engagement Solutions ===
• Established Flutter multi-platform standards, reducing development costs by 40% while maintaining high quality across iOS and Android stores.
• Successfully launched 4 Flutter-based applications (APP Rewards, CMI Dashboard, DDR Stationary, and ATown) on the Apple App Store.
• Delivered the JTMarine Forestry app to digitalize wood log tracking and live tracking at canals, ensuring supply chain integrity and preventing fraud.
• Launched ATown, the first internal mobile app for employee engagement, and APP Loyalty Rewards for digital voucher redemption.

=== Recognition & Vision ===
• Recognized as one of the 'Top 36 Best Employees' across APP Indonesia in 2024 and 'Top 1 Best Employee HQ' for result-oriented performance.
• Passionate about inspiring the next generation of digital leaders and advocating for ethical technology use and digital literacy for broader social impact.`,
  },
  {
    id: '4',
    name: 'Dendy Herryadi',
    organization: 'APP Forestry',
    pillar: 'Pulp & Paper',
    orgUnit: 'APP Forestry',
    title: 'Head of Peatland Best Practice',
    teamMembers: [],
    description:
      'Integrated Water Management: Leveraging IoT sensors and AI for predictive hydrological modeling to optimize peatland productivity and sustainably manage the world’s largest peatland plantations.',
    image: '/awards/winner-4.jpg',
    award: 'Innovation Excellence',
    year: 2025,
    category: 'team',
    linkedIn: '#',
    projectLink: '#',
    details: `=== Project Overview & Breakthrough ===
• Water Table (WT) is the single most critical factor for plantation productivity in peatland. APP, the world's largest peatland manager, has pioneered a global first by implementing high-tech hydrological science.
• Traditionally, WT data was collected manually from 280 points every two weeks. This project transforms manual monitoring into a real-time, daily digital intelligence system.
• This breakthrough allows for predictive water management, ensuring optimal growth conditions and robust fire prevention through superior moisture control.

=== Technological Innovation ===
• Deployed 25 specialized IoT sensors across plantation sites to continuously measure Water Table, Water Level, and local weather patterns.
• Utilizes Machine Learning (ML) and Artificial Intelligence (AI) for advanced Hydrological modeling and WT predictive forecasting up to 10 days in advance.
• Currently successfully implemented across 4 districts in Riau, covering 72,000 hectares of high-value plantation area.

=== Economic & Operational Impact ===
• Achieved a Mean Annual Increment (MAI) increase of 2.2%, resulting in an additional 41,000 tons of wood production per year.
• The initiative delivers a direct economic benefit of approximately $1.2 million USD per year from the initial implementation areas alone.
• Improved material usage accuracy and operational transparency by shifting from manual estimations to data-driven, precise calculations.

=== Scalability & Future Roadmap ===
• Scaling implementation to cover 12 districts (281,000 hectares) in Riau by the end of 2026.
• Established strict success criteria: Algorithm F1-Score accuracy >85% and maintaining desired WT levels across 80% of the area at all times.
• Targets a 1-day response time to critical alerts, significantly enhancing field responsiveness to changing environmental conditions.`,
  },
  {
    id: '5',
    name: 'Jo Jhony',
    organization: 'Sinar Mas Agribusiness and Food',
    pillar: 'Agri-business & Food',
    orgUnit: 'Upstream',
    title: 'BRAIN Plantation Head',
    teamMembers: [],
    description:
      'Fire Prevention Through AI-Powered Early Detection CCTV: Leveraging AI-powered CCTV cameras and computer vision to automatically identify early signs of fire and smoke in plantations.',
    image: '/awards/winner-5.jpg',
    award: 'Sustainable Solution',
    year: 2025,
    category: 'team',
    linkedIn: '#',
    projectLink:
      'https://srxaiagents.blob.core.windows.net/uploads/submissions/1756741845066_SMDD_Award_2025_-_Sinar_Mas_Agribusiness_and_Food_-_Sustainable_Solution_Award_-_Fire_Prevention_Through_AI-Powered_Early_Detection_CCTV.pptx?sv=2025-07-05&spr=https&se=2027-09-01',
    videoUrl:
      'https://srxaiagents.blob.core.windows.net/uploads/submissions/1756741853835_SMDD_Award_2025_-_Sinar_Mas_Agribusiness_and_Food_-_Sustainable_Solution_Award_-_Fire_Prevention_Through_AI-Powered_Early_Detection_CCTV.mp4?sv=2025-07-05&spr=https&se=2027-09-01T',
    details: `=== Environmental Impact and Sustainability ===

• AI-powered fire detection aims to prevent land and forest fires, reducing potential greenhouse gas emissions.
• Integration reduces costs associated with replanting and maintenance by preventing fires.
• Less damage to biodiversity and soil fertility through early fire detection and prevention efforts.

=== Innovation and Technology Used ===

• AI-powered CCTV system replaces costly and limited fire watch towers, enhancing real-time monitoring and coverage.
• Utilizes a 360° pan, optical zoom view, and height advantage for enhanced visibility compared to traditional methods.
• AI model developed in-house using diverse image datasets, incorporating open-source technology for effective smoke detection.

=== Scalability and Implementation Success ===

• Current roll-out includes 11 estates with plans to expand to 9 more, indicating growing adoption.
• System configuration and monitoring implemented in estate offices for centralized management and quick response.
• AI system covers areas more efficiently, allowing 200 CCTVs to replace 1000 fire watch towers, enhancing scalability.`,
  },
  {
    id: '6',
    name: 'Evi Arianto',
    organization: 'APP Group',
    pillar: 'Pulp & Paper',
    orgUnit: 'Corporate Information Technology',
    title: 'Manager IT Customer Related Automation',
    teamMembers: [],
    description:
      'Digital Transformation Leader: Driving large-scale automation in sales and distribution, implementing AI-powered merchandising, and pioneering e-commerce solutions to optimize field operations and customer engagement.',
    image: '/awards/winner-6.jpg',
    award: 'Women in Tech',
    year: 2025,
    category: 'individual',
    linkedIn: '#',
    projectLink: '#',
    details: `=== Business Transformation & Impact ===

• Led digital transformation for Tissue and Paper Business Units, implementing Sales Force Automation and Distribution Management Systems across 129 distributors and 1,200+ sales personnel.
• E-Commerce for CMI Direct Customer initiative eliminated 1,075 manual sales confirmations per month, delivering a financial benefit of $47,616 per year.
• Integrated a loyalty platform that reduced redemption process lead time from 120 days to just 3 days.
• Applied Geospatial intelligence to optimize store coordinates, improving daily sales efficiency and enabling seamless territory handovers.
• Implemented a 'Sales Blitz Strategy' that increased active outlets by 25,575 and revenue by $255,750, while avoiding $611,748 in annual Google Maps API costs.

=== Leadership & Mentorship ===

• Successfully mentored 4 out of 10 team members to become HQ Best Employee candidates, with one securing Runner-up at the APP Level 2.
• Actively mentors project leaders across multiple business units, focusing on technical execution, strategic business impact, and a resilient "APP iron army" mindset.
• Developed internal (simshop.com) and external (simpaper.com) e-commerce solutions to foster brand engagement and expand market reach.

=== Future Vision & Innovation ===

• Developing a mobile sales activity application integrating AI to deliver real-time insights for sales managers during customer visits.
• Focuses on bridging data and action to transform routine field operations into strategic touchpoints for operational excellence.`,
  },
];
